import * as React from 'react';
import LinearProgress from '@mui/material/LinearProgress';

export default function ProgressBar({ showProgress, color }) {


  return (
    <>
      {showProgress === true ? <LinearProgress sx={{mt:2, mb:1}} color={color == null ? "primary" : color} /> : ""}
    </>
  );
}